import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Transition } from 'history';

import { useBlocker } from './useBlocker';

export const useCallbackPrompt = (
  when: boolean,
  confirmCallback?: () => void,
  cancelCallback?: () => void | boolean,
) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPrompt, setShowPrompt] = useState(false);
  const [lastLocation, setLastLocation] = useState<any>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  // handle blocking when user click on another route prompt will be shown
  const handleBlockedNavigation = useCallback(
    (nextLocation: Transition) => {
      // in if condition we are checking next location and current location are equals or not
      if (!confirmedNavigation && nextLocation.location.pathname !== location.pathname) {
        setShowPrompt(true);
        setLastLocation(nextLocation);

        return false;
      }

      return true;
    },

    [confirmedNavigation, location],
  );

  const cancelNavigation = useCallback(() => {
    setShowPrompt(false);
    setLastLocation(null);
  }, []);

  const cancelNavigationRedirect = useCallback(() => {
    setShowPrompt(false);
    setConfirmedNavigation(true);

    if (!cancelCallback) return;
    cancelCallback();
  }, [cancelCallback]);

  const confirmNavigation = useCallback(() => {
    setShowPrompt(false);
    setConfirmedNavigation(true);

    if (!confirmCallback) return;
    confirmCallback();
  }, [confirmCallback]);

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation.location?.pathname);

      // Clean-up state on confirmed navigation
      setConfirmedNavigation(false);
    }
  }, [confirmedNavigation, lastLocation]);

  useBlocker(handleBlockedNavigation, when);

  return {
    showPrompt,
    confirmNavigation,
    cancelNavigation,
    cancelNavigationRedirect,
  };
};
